module.exports = __webpack_public_path__ + "static/img/banner_img3_sj.f348e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_img3_sj.png
// module id = pJi/
// module chunks = 11